import format from 'date-fns/format';

import { placeNames } from './useFieldsData';
import { useRequestsHandler } from './useRequestsHandler';

import { Place } from '../schemas';

type CalendeskValidationResponse = {
  success: boolean;
  error: boolean;
};

export const useValidateCalendeskRequest = () => {
  const { postRequest } = useRequestsHandler();

  const validateCalendeskBooking = async ({
    date,
    time,
    place,
    email
  }: {
    date: Date | null;
    time: string;
    place: Place;
    email: string;
  }): Promise<CalendeskValidationResponse> => {
    const formattedDate = format(date as Date, 'yyyy-MM-dd');
    const formattedPlace = placeNames[place].toUpperCase();

    try {
      const response = await postRequest<CalendeskValidationResponse>(
        'validateCalendesk',
        {
          date: formattedDate,
          time,
          place: formattedPlace,
          email
        }
      );
      return response.data;
    } catch {
      return {
        success: false,
        error: true
      };
    }
  };

  return { validateCalendeskBooking };
};
